var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classes,style:(_vm.btnStyle),attrs:{"type":_vm.type,"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }